import { lazy } from 'react'

import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const TransferenciasSolicitudApp = lazy(() => import('./view/Transferencias'))
const TransferenciasSolicitarRegistroApp = lazy(
  () => import('./view/TransferenciasRegistro'),
)
const TransferenciasActualizarApp = lazy(() => import('./view/TransferenciasActualizar'))
const TransferenciasAceptacionApp = lazy(() => import('./view/TransferenciasAceptacion'))
const TransferenciasAceptacionFormulario = lazy(
  () => import('./view/TransferenciasAceptacionRegistro'),
)
const TransferenciasConsultarApp = lazy(() => import('./view/TransferenciasConsultar'))
const TransferenciasConsultarFormulario = lazy(
  () => import('./view/TransferenciasConsultarFormulario'),
)

export const transferenciasRoutesMap = {
  transferencia: {
    path: '/transferencias/upsert',
    name: 'Registrar Transferencia',
  },
  aprobar: {
    path: '/transferencias/aprobar',
    name: 'Aprobar Transferencia',
  },
  aprobacionRegistro: {
    path: '/transferencias/aprobar/:id',
    name: 'Aprobar Transferencias',
  },
  registro: {
    path: '/transferencias/nuevo',
    name: 'Nueva Transferencia',
  },
  actualizar: {
    path: '/transferencias/actualizar/:id',
    name: 'Actualizar Transferencia',
  },
  consultar: {
    path: '/transferencias/consultar',
    name: 'Consultar Transferencia',
  },
  consultaForm: {
    path: '/transferencias/consultar/:id',
    name: 'Consultar Detallada',
  },
}

const transferenciasRoutes = [
  {
    path: transferenciasRoutesMap.transferencia.path,
    element: (
      <OperacionesProvider>
        <TransferenciasSolicitudApp />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <TransferenciasSolicitarRegistroApp />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <TransferenciasActualizarApp />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.aprobar.path,
    element: (
      <OperacionesProvider>
        <TransferenciasAceptacionApp />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.aprobacionRegistro.path,
    element: (
      <OperacionesProvider>
        <TransferenciasAceptacionFormulario />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.consultar.path,
    element: (
      <OperacionesProvider>
        <TransferenciasConsultarApp />
      </OperacionesProvider>
    ),
  },
  {
    path: transferenciasRoutesMap.consultaForm.path,
    element: (
      <OperacionesProvider>
        <TransferenciasConsultarFormulario />
      </OperacionesProvider>
    ),
  },
]

export default transferenciasRoutes
